import { render, staticRenderFns } from "./IconWithText.vue?vue&type=template&id=443b38d3&scoped=true&"
import script from "./IconWithText.vue?vue&type=script&lang=ts&"
export * from "./IconWithText.vue?vue&type=script&lang=ts&"
import style0 from "./IconWithText.vue?vue&type=style&index=0&id=443b38d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b38d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
